






import Vue from 'vue'

export default Vue.extend({
	props: {
		trackId: String,
	},

	computed: {
		classes() {
			return `track${this.trackId}`
		},

		trackName() {
			if(this.trackId == 12)
				return "VARGENS STIG";
			else if(this.trackId == 28)
				return "BJÖRNENS STIG";
			else if(this.trackId == 45)
				return "RENENS STIG";
			else if(this.trackId == 84)
				return "JÄRVENS STIG";
		}
	}
})
